import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { deleteProductPdf, getDownloadsLibrary } from "data/adminApi";
import { ArrowDownTrayIcon, TrashIcon } from "@heroicons/react/24/outline";

const AdminDownloads: FC = () => {
  const [items, setItems] = useState<
    Array<{
      product_sku: string;
      product_name: string;
      slot: number;
      name: string;
      url: string;
    }>
  >([]);
  const [message, setMessage] = useState("");

  const load = async () => {
    const data = await getDownloadsLibrary();
    setItems(data.results);
  };

  useEffect(() => {
    load().catch(() => setMessage("Failed to load downloads."));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold">Downloads library</h1>
      <p className="mt-1 text-sm text-neutral-500">
        All product PDFs across the catalogue. Attach new files from a product
        edit page.
      </p>
      {message && (
        <div className="mt-4 rounded-xl bg-red-50 text-red-700 text-sm px-4 py-3">
          {message}
        </div>
      )}

      <div className="mt-6 rounded-2xl border bg-white dark:bg-neutral-900 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-neutral-50 dark:bg-neutral-800/50 text-left">
            <tr>
              <th className="px-4 py-3 font-semibold">Product</th>
              <th className="px-4 py-3 font-semibold">SKU</th>
              <th className="px-4 py-3 font-semibold">File</th>
              <th className="px-4 py-3 font-semibold">Slot</th>
              <th className="px-4 py-3 font-semibold text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y dark:divide-neutral-800">
            {items.map((item, i) => (
              <tr key={`${item.product_sku}-${item.slot}-${i}`}>
                <td className="px-4 py-3">{item.product_name}</td>
                <td className="px-4 py-3 font-mono text-xs">
                  {item.product_sku}
                </td>
                <td className="px-4 py-3 truncate max-w-xs">{item.name}</td>
                <td className="px-4 py-3">{item.slot}</td>
                <td className="px-4 py-3">
                  <div className="flex justify-end gap-2">
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                      className="p-2 rounded-lg hover:bg-neutral-100"
                    >
                      <ArrowDownTrayIcon className="w-4 h-4" />
                    </a>
                    <Link
                      to={`/admin/products/${encodeURIComponent(
                        item.product_sku
                      )}/edit`}
                      className="text-xs font-semibold text-primary-600 px-2 py-2"
                    >
                      Edit
                    </Link>
                    <button
                      type="button"
                      className="p-2 rounded-lg hover:bg-red-50 text-red-600"
                      onClick={async () => {
                        await deleteProductPdf(item.product_sku, item.slot);
                        await load();
                      }}
                    >
                      <TrashIcon className="w-4 h-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr>
                <td
                  colSpan={5}
                  className="px-4 py-10 text-center text-neutral-500"
                >
                  No PDF documents found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDownloads;
